import styled from 'styled-components';

export const StyledNameMatchDocSection = styled.div`
  .alternate-doc-header {
    margin-bottom: 0.25rem;
  }
`;
